import isNil from 'lodash/isNil';

import type { ContextLoaderStore } from '../ContextLoader';

export const emptyContextLoader: ContextLoaderStore = {
  Address: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  BankAccount: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Building: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  BuildingOwner: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Contact: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Lease: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  LeaseContact: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Notification: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Team: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Technic: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  TechnicLibrary: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Ticket: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  Unit: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  UnitLease: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  UnitOwner: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  User: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  UserRole: { data: [], loading: false, shouldFetch: false, lastFetch: null },
  UserTeam: { data: [], loading: false, shouldFetch: false, lastFetch: null },
};

export const isContextLoaderLoading = (store: ContextLoaderStore, fetchRequested: boolean): boolean =>
  !fetchRequested ||
  Object.values(store).some((model) => isNil(model.lastFetch) && (model.loading || model.shouldFetch));
